import React from "react";
import { Check } from "lucide-react";
import { useSite } from "../lib/SiteContext";
import { mediaUrl } from "../lib/api";

const FleetSection = () => {
  const { content } = useSite();
  const f = content?.fleet || {};
  return (
    <section id="fleet" className="section-padding bg-muted/40" data-testid="fleet-section">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <div className="aspect-[16/11] overflow-hidden">
              <img src={mediaUrl(f.image_url)} alt="Boat" className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="lg:col-span-5">
            <div className="overline mb-4">{f.overline}</div>
            <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-primary mb-6 leading-tight">
              {f.title}
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-8">{f.body}</p>
            <ul className="grid grid-cols-2 gap-3">
              {(f.features || []).map((feat, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-foreground/85">
                  <Check size={16} className="text-secondary mt-0.5 shrink-0" />
                  {feat}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FleetSection;
